import { Component, inject, OnInit } from '@angular/core';
import { PrimeNG } from 'primeng/config';
import { IonApp, IonRouterOutlet } from '@ionic/angular/standalone';
import { SlideMenu } from './components/menu/slide-menu/slide-menu';
import { WaitComponent } from './components/wait-component/wait.component';
import { NotificationToastComponent } from './components/notification-toast/notification-toast.component';
import { A2hsHint } from './components/a2hs-hint/a2hs-hint';
import { RouterLoadingService } from './service/router-loading.service';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [
    IonApp,
    IonRouterOutlet,
    SlideMenu,
    WaitComponent,
    NotificationToastComponent,
    A2hsHint,
  ],
  templateUrl: './app.html',
})
export class App implements OnInit {
  constructor() {
    // Register icons used in the template
  }
  private primeng = inject(PrimeNG);
  private routerLoadingService = inject(RouterLoadingService);

  ngOnInit(): void {
    this.primeng.ripple.set(true);
    // Boot-time authentication is handled by provideAppInitializer (silent cookie refresh) in app.config.ts.
  }
}
